import { PayloadAction } from "@reduxjs/toolkit";
import { message } from "antd";
import { call, put, takeLatest } from "redux-saga/effects";
import api from "service/apiService";
import { ApiResponse } from "types";
import { translate } from "utils";
import { Store } from "../types";
import {
	getListStoreAsync,
	GetListStoreAsyncPayload,
	setListStore,
	getStoreDetailAsync,
	GetStoreDetailAsyncPayload,
	setStoreDetail,
	createStoreAsync,
	CreateStoreAsyncPayload,
	updateStoreAsync,
	UpdateStoreAsyncPayload,
	setLoading,
} from "./store.slice";

// Get list
function* getListStoreSaga(action: PayloadAction<GetListStoreAsyncPayload>) {
	yield put({ type: setLoading.type, payload: true });
	const { response, error } = yield call(async () => {
		const { query } = action.payload;
		if (query.merchantId) {
			query.merchant = +query.merchantId;
		}
		try {
			const { data: response } = await api.get<ApiResponse<Store[]>>(
				`/dashboard/car-stores`,
				query
					? {
							...query,
							skip: query.skip * query.take,
					  }
					: {},
			);
			return { response };
		} catch (error) {
			return { error };
		}
	});
	if (response) {
		yield put({ type: setListStore.type, payload: response });
	} else {
		message.error(translate(error.message));
	}
	yield put({ type: setLoading.type, payload: false });
}
function* watchGetListStore() {
	yield takeLatest(getListStoreAsync, getListStoreSaga);
}

// Get detail
function* getStoreDetailSaga(
	action: PayloadAction<GetStoreDetailAsyncPayload>,
) {
	yield put({ type: setLoading.type, payload: true });
	const { response, error } = yield call(async () => {
		const { storeId } = action.payload;
		try {
			const { data: response } = await api.get<ApiResponse<Store>>(
				`/dashboard/car-stores/${storeId}`,
			);
			return { response };
		} catch (error) {
			return { error };
		}
	});
	if (response) {
		yield put({ type: setStoreDetail.type, payload: response.data });
	} else {
		message.error(translate(error.message));
	}
	yield put({ type: setLoading.type, payload: false });
}
function* watchGetStoreDetail() {
	yield takeLatest(getStoreDetailAsync, getStoreDetailSaga);
}

// create
function* createStoreSaga(action: PayloadAction<CreateStoreAsyncPayload>) {
	yield put({ type: setLoading.type, payload: true });
	const { data, onSuccess } = action.payload;
	const { response, error } = yield call(async () => {
		try {
			const { data: response } = await api.post<ApiResponse<Store[]>>(
				`/dashboard/car-stores`,
				data,
			);
			return { response };
		} catch (error) {
			return { error };
		}
	});
	if (response) {
		message.success(translate("Create successful"));
		if (onSuccess) onSuccess(response.data);
	} else {
		message.error(translate(error.message));
	}
	yield put({ type: setLoading.type, payload: false });
}
function* watchCreateStore() {
	yield takeLatest(createStoreAsync, createStoreSaga);
}

// update
function* updateStoreSaga(action: PayloadAction<UpdateStoreAsyncPayload>) {
	yield put({ type: setLoading.type, payload: true });
	const { storeId, data } = action.payload;
	const { response, error } = yield call(async () => {
		try {
			const { data: response } = await api.put<ApiResponse<Store[]>>(
				`/dashboard/car-stores/${storeId}`,
				data,
			);
			return { response };
		} catch (error) {
			return { error };
		}
	});
	if (response) {
		message.success(translate("Update successful"));
		yield put({ type: getStoreDetailAsync.type, payload: { storeId } });
	} else {
		message.error(translate(error.message));
	}
	yield put({ type: setLoading.type, payload: false });
}
function* watchUpdateStore() {
	yield takeLatest(updateStoreAsync, updateStoreSaga);
}

const storeSaga = [
	watchGetListStore(),
	watchGetStoreDetail(),
	watchCreateStore(),
	watchUpdateStore(),
];
export default storeSaga;
